var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDnaGlucoseManagement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 213,
    viewBox: "0 0 213 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.6 205.391C162.06 205.391 207 160.841 207 105.9C207 50.9593 162.06 6.40918 106.6 6.40918C51.1395 6.40918 6.19971 50.9593 6.19971 105.9C6.19971 160.841 51.1395 205.391 106.6 205.391Z",
    fill: "#1C8078"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.73 35.3735C106.34 35.8931 105.95 36.4126 105.691 36.6724C91.9229 58.1032 78.0253 79.2742 64.3875 100.705C60.2313 107.199 57.8934 114.732 57.2439 122.525C54.6463 153.957 81.4023 179.674 112.834 175.908C149.072 171.492 168.424 130.318 148.422 99.666C143.617 92.2626 138.811 84.7293 134.005 77.326C124.654 63.4284 115.821 49.6607 106.73 35.3735Z",
    fill: "#E6393D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.73 35.3735C115.951 49.6607 124.913 63.4284 133.875 77.326C138.681 84.7293 143.487 92.2626 148.292 99.666C168.165 130.189 149.072 171.492 112.704 175.908C81.2723 179.674 54.6462 153.957 57.114 122.525C57.6335 114.732 59.9714 107.459 64.2576 100.705C78.0252 79.2742 91.9228 58.1032 105.561 36.6724C105.82 36.4126 106.08 36.1528 106.73 35.3735Z",
    fill: "#E6393D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.939 110.576H77.2466V152.269H118.939V110.576Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2466 110.576L90.235 96.1587H132.187L119.199 110.576H77.2466Z",
    fill: "#F2F2F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.198 152.398V110.576L132.187 96.1587V137.981L119.198 152.398Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnaGlucoseManagement);
export default __webpack_public_path__ + "static/media/DNA_Glucose_Management.ac5c2f23d0986c10a7d791e0d9234d91.svg";
export { ForwardRef as ReactComponent };